export default function Products() {
  return (
    <section id="products" className="py-32 bg-[#FAF9F7]">
      <div className="max-w-[1400px] mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-20">
          <h2 className="text-7xl font-serif text-[#2A2A2A] mb-6">Our Solutions</h2>
          <p className="text-xl text-[#6B6B6B] font-light">
            Premium iOS applications designed for security and performance
          </p>
        </div>

        {/* Product Grid */}
        <div className="grid grid-cols-3 gap-10">
          {/* VPN Product Card */}
          <div className="rounded-[28px] overflow-hidden shadow-lg hover:shadow-2xl transition-shadow duration-300 cursor-pointer group">
            <div className="relative h-96 bg-gradient-to-br from-[#4A90E2] to-[#50E3C2] p-8 flex items-center justify-center">
              <img 
                src="https://public.readdy.ai/ai/img_res/0c57c1fbc6a1a9a16e61984771a0f713.jpg"
                alt="VPN Protection"
                className="w-full h-full object-contain opacity-90 group-hover:scale-110 transition-transform duration-300"
              />
              <div className="absolute top-6 right-6 w-20 h-20 rounded-full bg-white/30 backdrop-blur-sm flex items-center justify-center">
                <span className="text-white text-xs font-bold tracking-wide">PREMIUM</span>
              </div>
            </div>
            <div className="bg-gradient-to-b from-[#4A90E2]/90 to-[#50E3C2]/90 p-8">
              <h3 className="text-3xl font-bold text-white mb-4">VPN Protection</h3>
              <p className="text-white/80 leading-relaxed">
                Secure your online presence with military-grade encryption. Browse anonymously, access global content, and protect your data on any network.
              </p>
            </div>
          </div>

          {/* Cleaner Product Card */}
          <div className="rounded-[28px] overflow-hidden shadow-lg hover:shadow-2xl transition-shadow duration-300 cursor-pointer group">
            <div className="relative h-96 bg-gradient-to-br from-[#FF6B4A] to-[#FFB347] p-8 flex items-center justify-center">
              <img 
                src="https://readdy.ai/api/search-image?query=Minimalist%20white%20line%20art%20illustration%20of%20broom%20with%20sparkle%20stars%20and%20cleaning%20symbols%20on%20transparent%20background%2C%20clean%20modern%20icon%20design%20for%20system%20cleaner%20application%20with%20geometric%20patterns%20and%20optimization%20theme&width=400&height=400&seq=cleaner-icon-001&orientation=squarish"
                alt="System Cleaner"
                className="w-full h-full object-contain opacity-90 group-hover:scale-110 transition-transform duration-300"
              />
              <div className="absolute top-6 right-6 w-20 h-20 rounded-full bg-white/30 backdrop-blur-sm flex items-center justify-center">
                <span className="text-white text-xs font-bold tracking-wide">ESSENTIAL</span>
              </div>
            </div>
            <div className="bg-gradient-to-b from-[#FF6B4A]/90 to-[#FFB347]/90 p-8">
              <h3 className="text-3xl font-bold text-white mb-4">System Cleaner</h3>
              <p className="text-white/80 leading-relaxed">
                Optimize your device performance with intelligent cleaning. Remove unnecessary files, free up storage, and keep your iOS device running like new.
              </p>
            </div>
          </div>

          {/* Coming Soon Card */}
          <div className="rounded-[28px] border-2 border-dashed border-gray-300 bg-white p-8 flex flex-col items-center justify-center text-center hover:border-[#FF6B4A] transition-colors duration-300 cursor-pointer group">
            <div className="w-32 h-32 rounded-full bg-gray-100 flex items-center justify-center mb-8 group-hover:bg-[#FF6B4A]/10 transition-colors duration-300">
              <i className="ri-question-line text-6xl text-gray-300 group-hover:text-[#FF6B4A] transition-colors duration-300"></i>
            </div>
            <h3 className="text-3xl font-bold text-[#2A2A2A] mb-4">More Innovation Coming</h3>
            <p className="text-[#6B6B6B] leading-relaxed max-w-xs">
              We're constantly developing new solutions to enhance your mobile experience. Stay tuned for exciting updates.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
